import { Box, styled, Typography, useTheme } from "@material-ui/core";
import { graphql } from "gatsby";
import React from "react";

const Wrapper = styled("div")(({ theme }) => ({
  backgroundColor: "#055023",
  padding: theme.spacing(4),
  borderRadius: theme.spacing(1),
  flex: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.05)",
  position: "relative",
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(4, 2.5)
  }
}));

const NumberTypography = styled(Typography)(({ theme }) => ({
  fontSize: "5rem",
  lineHeight: "5.6rem",
  color: theme.palette.common.white,
  paddingBottom: theme.spacing(1.5),
  marginBottom: theme.spacing(2),
  textAlign: "center",
  borderBottom: `1px solid rgba(0, 4, 2, 0.2)`,
  [theme.breakpoints.down("sm")]: {
    fontSize: "4rem",
    lineHeight: "4.2rem"
  }
}));

const Card = ({ number, title }: { number: number; title: string }) => {
  return (
    <Wrapper>
      <Box mb={{ xs: 0, md: 0 }} textAlign="center">
        <NumberTypography variant="h3">{number}</NumberTypography>
        <Typography
          variant="body1"
          className="white"
          style={{ lineHeight: 1.05 }}
        >
          {title}
        </Typography>
      </Box>
    </Wrapper>
  );
};

export default function MedicalCardsSection({
  card1Title,
  card2Title,
  card3Title
}: Queries.DatoCmsMedicalCardsFragmentFragment) {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      style={{ gap: theme.spacing(3) }}
    >
      <Card number={1} title={card1Title} />
      <Card number={2} title={card2Title} />
      <Card number={3} title={card3Title} />
    </Box>
  );
}

export const MedicalCardsFragment = graphql`
  fragment DatoCmsMedicalCardsFragment on DatoCmsCModuleMedicalCardsSection {
    card1Title
    card2Title
    card3Title
    container
    innerContainer
    containerDisableGutters
    containerBackgroundColor
    model {
      apiKey
    }
  }
`;
